import "core-js/modules/es.array.push.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4a1a89ae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-group-container"
};
const _hoisted_2 = {
  class: "add-account"
};
const _hoisted_3 = {
  class: "pagination-box"
};
import { ElMessage, ElMessageBox } from 'element-plus';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import NewsGroupDialog from './components/NewsGroupDialog';
import { getNewGroup, delNewsGroup } from '@/api/news';
import { tableSchemas } from './config';
import Table from './components/Table';
export default {
  __name: 'index',
  setup(__props) {
    const tableData = ref([]);
    const currentPage = ref(1);
    const total = ref(0);
    const pageSize = ref(8);
    const loading = ref(false);
    /**
     * 获取广告组分页
     */
    const getNewsGroupData = async () => {
      loading.value = true;
      const res = await getNewGroup({
        currentPage: currentPage.value,
        pageSize: 10
      });
      tableData.value = res.records;
      total.value = res.total;
      currentPage.value = res.current;
      loading.value = false;
    };
    getNewsGroupData();

    // 控制新增广告组隐藏显示
    const newsGroupVisible = ref(false);

    /**
     * 新增广告组
     */
    const addNewsGroupHandler = () => {
      newsGroupVisible.value = true;
    };

    /**
     * 删除广告组
     */
    const handleDelNewsGroup = async row => {
      try {
        await ElMessageBox.confirm('是否删除该条广告组', '温馨提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        });
        loading.value = true;
        await delNewsGroup(row.id);
        ElMessage.success('删除成功');
        await getNewsGroupData();
      } catch (error) {} finally {
        loading.value = false;
      }
    };

    // 修改广告组显示隐藏
    const current = ref(null);
    const handleEditNewsGroup = row => {
      current.value = JSON.parse(JSON.stringify(row));
      newsGroupVisible.value = true;
    };

    /**
     * 查看广告位
     */
    const router = useRouter();
    const toNewsItemHandler = row => {
      router.push({
        path: `/operation/miniprogramAdvertisementManage/${row.id}`
      });
    };

    /**
     * 更改当前页码
     * @param {*} val
     */
    const handleCurrentChange = val => {
      currentPage.value = val;
      getNewsGroupData();
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "title-card",
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: addNewsGroupHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })), [[_directive_permission, ['appletNewsGroupAdd']]])])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Table), {
          schemas: _unref(tableSchemas),
          onDel: handleDelNewsGroup,
          onInfo: toNewsItemHandler,
          onUpdate: handleEditNewsGroup,
          tableData: tableData.value
        }, null, 8, ["schemas", "tableData"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_pagination, {
          class: "pagination",
          onCurrentChange: handleCurrentChange,
          "current-page": currentPage.value,
          "page-size": pageSize.value,
          total: total.value,
          layout: "total,  prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), _createVNode(_unref(NewsGroupDialog), {
        modelValue: newsGroupVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => newsGroupVisible.value = $event),
        onRefreshData: getNewsGroupData,
        model: current.value,
        onClearModel: _cache[1] || (_cache[1] = $event => current.value = null)
      }, null, 8, ["modelValue", "model"])]);
    };
  }
};